module.exports = __webpack_public_path__ + "assets/media/winter-day.217de95f.ogg";